import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { bootBlock, findBlocks } from '../../src/js/block-boot';

const MOBILE_BREAKPOINT = 768;
const roots = new Set();

function initLogoSliders(root) {
  findBlocks(root, '.logo-slider .swiper').forEach((el) => {
    if (el._swiperInstance) {
      return;
    }

    const container = el.closest('.logo-slider');

    el._swiperInstance = new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 16,
      navigation: {
        nextEl: container?.querySelector('.swiper-button-next'),
        prevEl: container?.querySelector('.swiper-button-prev'),
        addIcons: false,
      },
      a11y: {
        enabled: true,
      },
    });
  });
}

function destroyLogoSliders(root) {
  findBlocks(root, '.logo-slider .swiper').forEach((el) => {
    if (el._swiperInstance) {
      el._swiperInstance.destroy(true, true);
      el._swiperInstance = null;
    }
  });
}

function applyBreakpoint(root) {
  const view = (root.ownerDocument || root).defaultView;
  if (view.innerWidth <= MOBILE_BREAKPOINT) {
    initLogoSliders(root);
  } else {
    destroyLogoSliders(root);
  }
}

bootBlock('logo-slider', (root, { isEditor }) => {
  if (isEditor) {
    initLogoSliders(root);
    return;
  }

  roots.add(root);
  applyBreakpoint(root);
  window.addEventListener('resize', () => roots.forEach(applyBreakpoint));
});
